/**
 * ATL-1338 — whether the daily-stats feed should also fetch `/reports/shift` for this role.
 *
 * `/reports/shift` is gated on `Shift` (it carries per-wallet cash amounts), and its only reader is
 * ShiftScreen. `/reports/daily-stats` now also admits `NewSale` and `mainScreenStats`, so a role
 * holding either without `Shift` would load daily stats and then take a permanent 403 on the shift
 * report on every refetch — each one reported to Sentry twice. Such a role cannot open ShiftScreen,
 * so skipping the call loses nothing.
 *
 * The predicate is HomeScreen's own menu gate (`permissions[item.permission] || id === 'admin'`), so
 * the call is made exactly when the screen that needs it is reachable.
 *
 * An UNKNOWN role (the atom not populated yet at the first fetch) fetches: skipping on "don't know"
 * would render a Shift user's screen with zeros until the next refetch, which is the failure this
 * ticket is about. A 403 for a role that turns out to lack `Shift` is the cheaper mistake.
 */
export interface RoleLike {
  id?: string | null;
  permissions?: Record<string, unknown> | null;
}

export function shouldFetchShiftReport(role: RoleLike | null | undefined): boolean {
  if (!role) return true;
  return role.id === 'admin' || Boolean(role.permissions?.['Shift']);
}
